import BaseComponentController from "./base_component_controller"

export default class extends BaseComponentController {
  static values = {
    dismissClass: { type: String }
  }

  dismiss(event) {
    this.element.classList.add(this.dismissClassValue)
    this.dispatchEvent({ action: 'after-dismiss' })
  }
}
